import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import { GetPartCategoryTreeResponse, productInventoryEndpoints } from '@services/productInventory';
import { useQuery } from '@tanstack/react-query';

interface UseCurrentAndPreviousPartTreesQueryProps {
  account: string;
  productPID: string;
  configurationPID: string;
}

export type UseCurrentAndPreviousPartTreesQueryResult = {
  current: GetPartCategoryTreeResponse;
  previous: GetPartCategoryTreeResponse;
};

export const useCurrentAndPreviousPartTreesQuery = ({
  account,
  productPID,
  configurationPID,
}: UseCurrentAndPreviousPartTreesQueryProps) => {
  const categoryFields = ['salesName', 'salesDescription', 'prices', 'itemType'].join(',');
  const endpoint = `${productInventoryEndpoints.products}/${productPID}${productInventoryEndpoints.partCategories}`;

  const queryKey = ['getPartCategoryTrees', account, configurationPID];
  const { getService } = useProductInventory();

  const currentPartTreeQueryParams = {
    account,
    configurationPID,
    categoryFields,
    version: 'current',
  };
  const previousPartTreeQueryParams = {
    ...currentPartTreeQueryParams,
    version: 'previous',
  };

  return useQuery<UseCurrentAndPreviousPartTreesQueryResult>(queryKey, async () => {
    const service = await getService();
    const [currentPartTreeResponse, previousPartTreeResponse] = await Promise.all([
      service.get(`${endpoint}?${new URLSearchParams(currentPartTreeQueryParams)}`, {
        headers: { Accept: 'application/json' },
      }),
      service.get(`${endpoint}?${new URLSearchParams(previousPartTreeQueryParams)}`, {
        headers: { Accept: 'application/json' },
      }),
    ]);

    return {
      current: currentPartTreeResponse.data.payload,
      previous: previousPartTreeResponse.data.payload,
    };
  });
};
